import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import { MODULE_ANAGRAFICA, MODULE_CONFIGURAZIONE } from '../../app-routing.module';
import { Ruolo } from '../../+configurazione/ruolo/ruolo.model';
import { GerarchiaTreeService } from '../gerarchia-tree/gerarchia-tree.service';
import { Delega } from './delega.model';
import { RuoloService } from '../../+configurazione/ruolo/ruolo.service';
import { RuoloUtente } from '../../+configurazione/ruoloutente/ruoloutente.model';
import { Table } from '../../common/model/table.model';

@Injectable()
export class DelegaService extends CommonService<Delega> {

  public static ROUTE = 'delega';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected gerarchiaTreeService: GerarchiaTreeService,
                     protected ruoloService: RuoloService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Delega {
    return JsonBaseBuilder.jsonToDelega(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return DelegaService.ROUTE;
  }

  public getTable(items: Delega[]): Table {
    return Table.buildBaseTable(Delega.getTableKeys(), items);
  }

  public ruoliDelegabili(username: string): Observable<Ruolo[]> {

    return this.ruoloService.getArray( '/ruolidelegabili/' + username, new HttpParams(), this.getRequestMapping());
  }

}
